<template>
  <div
    class="container-fluid d-flex flex-column-reverse flex-sm-column-reverse flex-md-column-reverse flex-lg-row flex-xl-row"
  >
    <div class="col-12">
      <div class="d-flex flex-column">
        <div class="d-flex justify-content-between col-12 px-4">
          <TopDashboardBar /> <LeftNav />
        </div>

        <ProjectsList />
      </div>
    </div>
  </div>
</template>

<script>
import TopDashboardBar from "@/components/TopDashboardBar.vue";
import ProjectsList from "@/components/ProjectsList.vue";
import LeftNav from "../components/LeftNav.vue";
export default {
  components: {
    ProjectsList,
    TopDashboardBar,
    LeftNav,
  },
  created() {
    this.$store.dispatch("apiEvents/fetchProjectsByUserId", {
      id: localStorage.getItem("userId"),
    });
    this.$store.dispatch("apiEvents/fetchTracksByUserId", {
      id: localStorage.getItem("userId"),
    });
  },
  computed: {
    loggedIn() {
      return this.$store.state.apiEvents.jwt != "" ? 1 : 0;
    },
  },
};
</script>

<style></style>
